import { render, staticRenderFns } from "./NumberTile.vue?vue&type=template&id=b9dfe6b2&"
import script from "./NumberTile.vue?vue&type=script&lang=js&"
export * from "./NumberTile.vue?vue&type=script&lang=js&"
import style0 from "./NumberTile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
